import { colors, layout } from './../../../config/styles';

export default {
	container: {
		paddingTop			: layout.outerGutter,
		paddingLeft			: layout.outerGutter,
		paddingRight		: layout.outerGutter,
		paddingBottom		: layout.outerGutter/3,
		backgroundColor 	: colors.gray,
	},
	//First Row
	titleContainer: {
		width 			: '100%',
		display 		: 'flex',
		justifyContent 	: 'space-between',
		alignItems 		: 'center',
		marginBottom 	: layout.outerGutter/3
	},
	companyName: {
		color 			: colors.red,
		fontSize 		: 20,
		textAlign 		: 'left',
		fontWeight 		: 500,
		letterSpacing 	: 1,
		textTransform 	: 'uppercase',
	},
	companyCopy: {
		color 			: colors.red,
		fontSize 		: 20,
		textAlign		: 'right',
		letterSpacing 	: 1,
		fontWeight 		: 500,
		textTransform 	: 'uppercase',
	},

	navUl: {
		width 			: '100%',
		display 		: 'flex',
		margin 			: 0,
		padding 		: 0,
	},
	navLi: {
		listStyle 		: 'none',
		marginRight 	: 40,
		textTransform 	: 'uppercase',
	},
	link: {
		fontWeight 		: 300,
		fontSize 		: 14,
		color 			: colors.black,
		textDecoration	: 'none',
	},

	//subfooter
	subfooter : {
		display 		: 'flex',
		justifyContent 	: 'space-between',
		alignItems 		: 'center',
		width 			: '100%',
		marginTop 		: layout.outerGutter/3,
		paddingTop 		: layout.outerGutter/3,
	},
	footerLink: {
		fontWeight 		: 500,
		fontSize 		: 18,
		color 			: colors.black,
		textDecoration	: 'none',
		letterSpacing 	: 2,
	},
	logo: {
		width 			: 120
	}
}



// WEBPACK FOOTER //
// ./src/layout/Front/Footer/styles.js